import React from 'react';
import { Calendar, X, ChevronLeft, Settings, ChevronRight, Search, RefreshCw } from 'lucide-react';
import { getMonthName, getDayName, getMonthDay, getDaysInMonth } from '../utils/dateUtils';
import EventRow from '../components/EventRow';
import CustomSelect from '../components/CustomSelect';

import { SORT_OPTIONS } from '../constants/options';

export default function HomeScreen({
  currentDay, currentMonth,
  todayDay, todayMonth,
  navigateDay,
  events,
  setSortOrder,
  isSyncing, syncError, setSyncError,
  openEventDetail,
  setCurrentScreen,
  swipeHandlers,
}) {
  const isToday = currentDay === todayDay && currentMonth === todayMonth;

  return (
    <div
      className="h-full flex flex-col"
      onTouchStart={swipeHandlers.onTouchStart}
      onTouchMove={swipeHandlers.onTouchMove}
      onTouchEnd={swipeHandlers.onTouchEnd}
    >
      {/* Header */}
      <div className="bg-white border-b-2 border-gray-200 p-4">
        <div className="flex items-center justify-between mb-3">
          <h1 className="text-2xl font-bold">
            {getMonthDay(currentDay, currentMonth, todayDay, todayMonth)}
          </h1>
          <div className="flex items-center gap-2">
            <button
              onClick={() => setCurrentScreen('search')}
              className="p-2 hover:bg-gray-100 rounded-full"
            >
              <Search size={20} />
            </button>
            <button
              onClick={() => setCurrentScreen('month')}
              className="p-2 hover:bg-gray-100 rounded-full"
            >
              <Calendar size={20} />
            </button>
            <button
              onClick={() => setCurrentScreen('settings')}
              className="p-2 hover:bg-gray-100 rounded-full"
            >
              <Settings size={20} />
            </button>
          </div>
        </div>
        <div className="relative flex items-center justify-center">
          <button
            onClick={() => navigateDay(-1)}
            className="absolute left-0 p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <ChevronLeft size={20} className="text-gray-600" />
          </button>
          <div className="text-gray-600">
  {getDayName(currentDay, currentMonth, getDaysInMonth)}, {getMonthName(currentMonth)} {currentDay}</div>
          <button
            onClick={() => navigateDay(1)}
            className="absolute right-0 p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <ChevronRight size={20} className="text-gray-600" />
          </button>
        </div>
      </div>

      {/* Sync Status */}
      {isSyncing && (
        <div className="bg-blue-50 px-4 py-2 text-xs text-blue-600 text-center flex items-center justify-center gap-2">
          <RefreshCw size={12} className="animate-spin" />
          Syncing calendar events...
        </div>
      )}
      {syncError && !isSyncing && (
        <div className="bg-red-50 px-4 py-2 text-xs text-red-600 flex items-center justify-between">
          <span>{syncError}</span>
          <button onClick={() => setSyncError(null)} className="p-0.5 hover:bg-red-100 rounded ml-2">
            <X size={12} />
          </button>
        </div>
      )}

      {/* Today's Events */}
      <div className="flex-1 overflow-auto p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="text-sm font-semibold text-gray-700">
            {isToday ? "Today's Schedule" : `Schedule for ${getMonthName(currentMonth)} ${currentDay}`}
          </div>
          <CustomSelect options={SORT_OPTIONS} defaultValue="date_asc" size="xs" onChange={setSortOrder} className="w-24" />
        </div>
        <div className="space-y-3">
          {events.length > 0 ? (
            events.map(event => (
              <EventRow key={event.id} event={event} onClick={() => openEventDetail(event)} urgentSizing />
            ))
          ) : (
            <div className="text-center py-8">
              <div className="text-2xl mb-2">🎉</div>
              <div className="text-gray-900 font-semibold text-lg mb-1">Free day!</div>
              <div className="text-gray-500 text-sm">No events scheduled</div>
            </div>
          )}
        </div>
      </div>

    </div>
  );
}
